const Steps = {
  "coverage_map": {
    "path": "/coverage-map",
    "order": 1,
    "key": "coverage_map",
    "subs": [],
    "requires": ["!is_plan_paid"],
    "skip_if": ["skip_coverage_map"],
    "style": "vmo-plain-header"
  },
  "coverage_confirm": {
    "path": "/coverage-confirm",
    "order": 2,
    "key": "coverage_confirm",
    "subs": [],
    "requires": ["!is_plan_paid"],
    "skip_if": ["skip_coverage_map"],
    "style": "vmo-plain-header"
  },
  "residency": {
    "path": "/residency",
    "order": 3,
    "key": "residency",
    "subs": [],
    "requires": ["!is_plan_paid", "!is_plan_selected"],
    "skip_if": [],
    "style": "vmo-header-style-slant"
  },
  "coverage_details": {
    "path": "/plans",
    "order": 4,
    "key": "coverage_details",
    "subs": [],
    "requires": ["!is_plan_paid", "is_number_selected"],
    "skip_if": ["is_number_selected", "is_plan_selected"],
    "style": "vmo-header-style-slant"
  },
  "upsell": {
  "path": "/plan-upsell",
  "order": 5,
  "key": "upsell",
  "subs": [],
  "requires": ["!is_plan_paid", "is_number_selected", "is_plan_selected", "!isYearlyPlanSelected"],
  "skip_if": ["is_number_selected"],
  "style": "vmo-header-style-slant"
  },
  "account": {
    "path": "/login",
    "order": 6,
    "key": "account",
    "subs": [],
    "requires": ["!is_plan_paid", "!is_logged_in_via_email", "is_number_selected", "is_plan_selected"],
    "skip_if": ["is_logged_in_via_email"],
    "style": "vmo-header-style-slant"
  },
  "pay_online": {
    "path": "/collect-in-store",
    "order": 7,
    "key": "pay_online",
    "subs": [],
    "requires": ["is_logged_in_via_email", "!is_plan_paid", "is_plan_selected"],
    "skip_if": ["delivery_form"],
    "style": "vmo-header-style-slant"
  },

  "delivery": {
    "path": "/delivery",
    "order": 8,
    "key": "delivery",
    "subs": ["/delivery-closed"], 
    "requires": ["is_logged_in_via_email", "is_plan_selected", "is_number_selected"],
    "skip_if": ["delivery_form"],
    "style": "vmo-header-style-slant"
  },
    "delivery_type": {
    "path": "/delivery_type",
    "order": 9,
    "key": "delivery_type",
    "subs": [], 
    "requires": ["is_logged_in_via_email", "is_plan_selected", "is_number_selected"],
    "skip_if": ["delivery_form"],
    "style": "vmo-header-style-slant"
  },
    "delivery_address": {
    "path": "/delivery_address",
    "order": 10,
    "key": "delivery_address",
    "subs": [], 
    "requires": ["is_logged_in_via_email", "is_plan_selected", "is_number_selected"],
    "skip_if": ["delivery_form"],
    "style": "vmo-header-style-slant"
  },
  "payment": {
    "path": "/payment",
    "order": 11,
    "key": "payment",
    "subs": [],
    "requires": ["!is_plan_paid", "is_logged_in_via_email", "is_plan_selected", "is_number_selected"], 
    "skip_if": ["is_plan_paid"],
    "style": "vmo-header-style-slant"
  },
  "submit_delivery": {
    "path": "/submit-delivery",
    "order": 12,
    "key": "submit_delivery",
    "subs": [],
    "requires": ["is_plan_paid", "delivery_form"], 
    "skip_if": [],
    "style": "vmo-header-style-slant"
  },
  "thank_you": {
    "path": "/thank-you",
    "order": 13,
    "key": "thank_you",
    "subs": [],
    "requires": ["is_plan_paid", "go_to_thank_you"], 
    "skip_if": [""],
    "style": "vmo-plain-header"
  }
};

export default Steps;